<style lang="less" scoped>
.title-div {
    font-weight: 600;
    margin: 20px 0 10px;
    font-size: 26px;
    // flex-grow: 1;
    color: #000;
}

.history {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4182eb;
    line-height: 20px;
    height: 25px;
    margin-top: 35px;
    margin-left: 15px;
}

.custInfo_container {
    width: 100%;
    margin: 20px 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;

    .cust-item {
        width: 25%;
    }
}

.el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;

    >div:first-of-type {
        // width: 120px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    >div:last-of-type {
        font-size: 14px;
        min-width: 160px;
        text-align: right;
    }
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
    margin-bottom: 10px;
}

.cust-mes {
    margin: 0px 0px 14px 18px;
}

.top-title-div {
    font-size: 15px;
    margin-left: 10px;
}

.red-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 100px;
}

.detail-btn {
    height: 32px;
    margin-left: 45px;
    margin-top: 10px;
}

.account_item {
    width: 437px;
    height: 101px;
    background: #4182eb;
    border-radius: 22px;
    color: #fff;
    padding: 10px 20px;


    .amount_con {
        // flex-grow: 1;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

}
</style>

<template>
    <div class="detail-content-div">
        <div class="title-div">
            <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <el-tab-pane label="共享充电订单" name="first">

                    <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column align="center" prop="orderNo" label="共享充电订单ID" width="260" />
                        <el-table-column align="center" prop="reserveOrderNo" label="关联预约订单ID" width="240" />
                        <el-table-column align="center" prop="deviceTypeName" label="共享设备类型" width="200" />
                        <el-table-column align="center" prop="pileCode" label="充电设备编号/IME" width="240" />
                        <el-table-column align="center" prop="stationName" label="站点名称" width="240" />
                        <el-table-column align="center" prop="bindSourceName" label="充电业务归属" width="240" />
                        <el-table-column align="center" prop="custTypeName" label="充电用户账号类型" width="240" />
                        <el-table-column align="center" prop="shareStartTypeName" label="共享充电类型" width="240" />
                        <el-table-column align="center" prop="shareOrderStatusName" label="订单状态" width="240" />
                        <el-table-column align="center" prop="orderPropertyName" label="订单属性" width="240" />
                        <el-table-column align="center" prop="beginTime" label="开始时间" width="180" />
                        <el-table-column align="center" prop="startChargingTime" label="启动充电时间" width="180" />
                        <el-table-column align="center" prop="endTime" label="结束时间" width="180" />
                        <el-table-column align="center" prop="chargeOverReason" label="结束方式" width="240" />
                        <el-table-column align="center" prop="chargeMin" label="充电时长" width="160" />
                        <el-table-column align="center" prop="chargeVal" label="充电电量" width="160" />
                        <el-table-column align="center" prop="prePayFee" label="充电预付费用（元）" width="160" />
                        <el-table-column align="center" prop="actPayFee" label="充电实付费用（元）" width="160" />
                        <el-table-column align="center" prop="ordAmt" label="已退预付费用（元）" width="160" />
                        <el-table-column align="center" prop="actualRefAmt" label="已退实收费用（元）" width="160" />
                        <el-table-column align="center" prop="transStatusName" label="预付退款状态" width="160" />
                        <el-table-column align="center" prop="transFinishedTime" label="预付退款完成时间" width="160" />
                        <el-table-column align="center" prop="lastModifiedByName" label="更新人" width="140" />
                        <el-table-column align="center" prop="lastModifiedWhen" label="更新时间" width="180" />
                        <el-table-column align="center" prop="remark" label="备注" width="200" />
                    </el-table>
                    <!-- 分页 -->
                    <div class="list-pagination">
                        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getShareChargeData" />
                    </div>
                </el-tab-pane>
                <el-tab-pane label="共享预约订单" name="second">

                    <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }">
                        <el-table-column align="center" prop="reserveOrderNo" label="共享预约订单ID" width="240" />
                        <el-table-column align="center" prop="shareOrderId" label="关联预约订单ID" width="260" />
                        <el-table-column align="center" prop="reserveTypeName" label="共享预约类型" width="180" />
                        <el-table-column align="center" prop="pileCode" label="预约设备编号/IMEI" width="160" />
                        <el-table-column align="center" prop="custMobile" label="设备所属用户手机号" width="180" />
                        <el-table-column align="center" prop="custTypeName" label="充电用户账号类型" width="200" />
                        <el-table-column align="center" prop="custPhone" label="下单用户手机号" width="160" />
                        <el-table-column align="center" prop="stationName" label="站点名称" width="240" />
                        <el-table-column align="center" prop="stationAddr" label="站点地址" width="320" />
                        <el-table-column align="center" prop="bindSourceName" label="预约业务归属" width="240" />
                        <el-table-column align="center" prop="deviceTypeName" label="共享设备类型" width="200" />
                        <el-table-column align="center" prop="orderStatusName" label="订单状态" width="160" />
                        <el-table-column align="center" prop="localReserveBeginTime" label="当前预约开始时间" width="180" />
                        <el-table-column align="center" prop="localReserveEndTime" label="当前预约结束时间" width="180" />
                        <el-table-column align="center" prop="reserveTime" label="下单时间" width="180" />
                        <el-table-column align="center" prop="updateCount" label="修改次数" width="140" />
                        <el-table-column align="center" prop="beforeReserveBeginTime" label="原始预约开始时间" width="180" />
                        <el-table-column align="center" prop="beforeReserveEndTime" label="原始预约结束时间" width="180" />
                        <el-table-column align="center" prop="remark" label="备注" width="240" />
                        <el-table-column align="center" prop="lastModifiedWhen" label="更新时间" width="180" />
                    </el-table>
                    <!-- 分页 -->
                    <div class="list-pagination">
                        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getShareAppointmentData" />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import pageConfig from './page-config';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            pageConfig: pageConfig, // 页面配置
            tableData: [], // 表格数据
            activeName: "first",
            pagination: pageConfig.pagination,
            pageTitle: "客户详情",
            pileList: [], // 桩数据项
            // 默认值设置
            custInfo: {},
            queryInfo: {
              pileCode: '',
              deviceType: ''
            }, // 默认内容
            chargeCount: {},
        };
    },
    methods: {
        init() {
            let _ = this;
            const list = _.$store.state.pileObj || null
            if (list) {
                _.custInfo = _.$store.state.pileObj;
                _.queryInfo.userPhone = _.custInfo.mobile;
                _.queryInfo.pileCode = list.deviceCode || ''
                _.queryInfo.deviceType = list.deviceType || ''
                _.handleClick('first')
            }
        },

        handleClick(val) {
            let _ = this
            _.activeName = val.name || val;
            _.tableData = [];
            if (_.activeName == "first") {
                _.getShareChargeData(_.pagination, true)
            }
            if (_.activeName == "second") {
                _.getShareAppointmentData(_.pagination, true)
            }
        },

        // 获取共享充电订单表格数据
        getShareChargeData(pagination, reload = false) {
            let _ = this;
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                _.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.corpNo = _.$store.state.corpNo;

            _.$U.showLoading(_);
            _.$H.post(_, _.$A.cust.getChargePileOrder, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            });

            
        },
        // 获取共享预约表格数据
        getShareAppointmentData(pagination, reload = false) {
            let _ = this;
            _.$U.showLoading(_);
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                _.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.corpNo = _.$store.state.corpNo;
            _.$U.showLoading(_);
            _.$H.post(_, _.$A.cust.getSharePileOrder, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            });
        },

        resetQuery() {
            this.queryInfo = {
                searchKey: undefined,
            };
            this.getListData(this.pagination, true);
        },
    },
    mounted() {
        this.init();
    },
};
</script>
